import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Introduction from './components/Introduction';
import QuizSection from './components/QuizSection';
import Results from './components/Results';
import LegalNotice from './components/LegalNotice';
import './App.css';

function App() {
  const [currentStep, setCurrentStep] = useState('introduction');
  const [answers, setAnswers] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [showLegal, setShowLegal] = useState(false);

  const handleStartQuiz = (info) => {
    setUserInfo(info);
    setCurrentStep('quiz');
  };

  const handleQuizComplete = (quizAnswers) => {
    setAnswers(quizAnswers);
    setCurrentStep('results');
  };

  const handleRestart = () => {
    setCurrentStep('introduction');
    setAnswers({});
    setUserInfo({});
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <div className="container mx-auto px-4 py-8 flex flex-col min-h-screen">
        
        {/* Main Content - Hidden when Legal is shown to preserve state */}
        <div style={{ display: showLegal ? 'none' : 'block' }} className="flex-grow">
          <AnimatePresence mode="wait">
            {currentStep === 'introduction' && (
              <motion.div
                key="introduction"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Introduction onStart={handleStartQuiz} />
              </motion.div>
            )}
            
            {currentStep === 'quiz' && (
              <motion.div
                key="quiz"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <QuizSection onComplete={handleQuizComplete} userInfo={userInfo} />
              </motion.div>
            )}
            
            {currentStep === 'results' && (
              <motion.div
                key="results"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Results answers={answers} userInfo={userInfo} onRestart={handleRestart} />
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Legal Notice Page - Overlay */}
        {showLegal && (
          <div className="flex-grow">
             <LegalNotice onClose={() => setShowLegal(false)} />
          </div>
        )}

        {/* Footer */}
        {!showLegal && (
          <footer className="mt-12 text-center py-6 border-t border-gray-200/50">
            <div className="flex justify-center items-center space-x-6">
               <button
                onClick={() => setShowLegal(true)}
                className="text-sm text-gray-500 hover:text-blue-600 transition-colors font-medium border-b border-transparent hover:border-blue-600"
              >
                Impressum / Haftung
              </button>
            </div>
            <p className="text-xs text-gray-400 mt-2">
              © {new Date().getFullYear()} Internet Consulting Group Inc.
            </p>
          </footer>
        )}
      </div>
    </div>
  );
}

export default App;